import copy from 'helpers/copy.js';
import Store from 'store/store';
import { getDateNum } from 'utils/querySimulation';

export const flightList = [
	{
		id: 'mushroomKingdom',
		name: copy.$mushroomKingdom,
		status: 'boarding',
		icon: 'gmjsvg.webp',
		logoAlt: copy.$altLogoBoomerang,
		planet: {
			folder: 'm5tr3b',
			gallery: [
				'1.webp',
				'2.webp',
				'3.webp',
				'4.webp',
				'5.webp'
			],
			wallpapers: [
				{
					preview: '1.webp',
					mobileDownload: 'mobile/1.jpg',
					desktopDownload: 'desktop/1.jpg'
				},
				{
					preview: '2.webp',
					mobileDownload: 'mobile/2.jpg',
					desktopDownload: 'desktop/2.jpg'
				},
				{
					preview: '3.webp',
					mobileDownload: 'mobile/3.jpg',
					desktopDownload: 'desktop/3.jpg'
				},

			],
			copy: copy.$planetOverlays?.mushroomKingdom
		}
	},
	{
		id: 'honeyhiveGalaxy',
		name: copy.$honeyhiveGalaxy,
		status: 'boarding',
		icon: 'divxzz.webp',
		logoAlt: copy.$altLogoGalaxyAir,
		planet: {
			folder: 'ma6yga',
			gallery: [
				'1.webp',
				'2.webp'
			],
			wallpapers: [
				{
					preview: '1.webp',
					mobileDownload: 'mobile/1.jpg',
					desktopDownload: 'desktop/1.jpg'
				},
				{
					preview: '2.webp',
					mobileDownload: 'mobile/2.jpg',
					desktopDownload: 'desktop/2.jpg'
				}
			],
			copy: copy.$planetOverlays?.honeyhiveGalaxy
		}
	},
	{
		id: 'fossilFalls',
		name: copy.$fossilFalls,
		status: 'boarding',
		icon: 'gmjsvg.webp',
		logoAlt: copy.$altLogoBoomerang,
		planet: {
			folder: 'faz8rh',
			gallery: [
				'1.webp',
				'2.webp',
				'3.webp',
			],
			wallpapers: [
				{
					preview: '1.webp',
					mobileDownload: 'mobile/1.jpg',
					desktopDownload: 'desktop/1.jpg'
				},
				{
					preview: '2.webp',
					mobileDownload: 'mobile/2.jpg',
					desktopDownload: 'desktop/2.jpg'
				},
			],
			copy: copy.$planetOverlays?.fossilFalls
		}
	},
	{
		id: 'cometObservatory',
		name: copy.$cometObservatory,
		status: 'boarding',
		icon: 'ygmrsr.webp',
		logoAlt: copy.$altLogoSunshineAir,
		planet: {
			folder: 'rzdyk9',
			gallery: [
				'1.webp',
				'2.webp',
				'3.webp',
			],
			wallpapers: [
				{
					preview: '1.webp',
					mobileDownload: 'mobile/1.jpg',
					desktopDownload: 'desktop/1.jpg'
				},
				{
					preview: '2.webp',
					mobileDownload: 'mobile/2.jpg',
					desktopDownload: 'desktop/2.jpg'
				},
				{
					preview: '3.webp',
					mobileDownload: 'mobile/3.jpg',
					desktopDownload: 'desktop/3.jpg'
				},
			],
			copy: copy.$planetOverlays?.cometObservatory
		}
	},
	{
		id: 'tostarenaTown',
		name: copy.$tostarenaTown,
		status: (getDateNum() === '4') ? 'boarding' : 'delayed',
		icon: 'divxzz.webp',
		logoAlt: copy.$altLogoGalaxyAir,
		planet: {
			folder: 'rwxf1c',
			gallery: [
				'1.webp',
				'2.webp',
				'3.webp',
				'4.webp',
			],
			wallpapers: [
				{
					preview: '1.webp',
					mobileDownload: 'mobile/1.jpg',
					desktopDownload: 'desktop/1.jpg'
				},
				{
					preview: '2.webp',
					mobileDownload: 'mobile/2.jpg',
					desktopDownload: 'desktop/2.jpg'
				},
			],
			copy: copy.$planetOverlays?.tostarenaTown
		}
	},
	{
		id: 'dripDropGalaxy',
		name: copy.$dripDropGalaxy,
		status: (getDateNum() === '4') ? 'boarding' : 'delayed',
		icon: 'ygmrsr.webp',
		logoAlt: copy.$altLogoSunshineAir,
		easterEgg: (getDateNum() === '4') ? 'apshvv/mlf0tf' : undefined
	},
	{
		id: 'spaceJunkGalaxy',
		name: copy.$spaceJunkGalaxy,
		status: (getDateNum() === '4') ? 'boarding' : 'noFly',
		icon: 'divxzz.webp',
		logoAlt: copy.$altLogoGalaxyAir,
		upWorld: (getDateNum() === '4') ? true : undefined
	}
];

export const sidebarPopUps = [
	{
		id: 'boardingTimes',
		icon: 'wqpjke.webp',
		activeIcon: 'wqpjke-active.webp',
		idleIcon: 'wqpjke-idle.webp',
		hoverIcon: 'wqpjke-hover.webp',
		popUp: {
			copy: copy.$boardingTimes
		}
	},
	{
		id: 'passport',
		icon: 'fe7gme.webp',
		activeIcon: 'fe7gme-active.webp',
		idleIcon: 'fe7gme-idle.webp',
		hoverIcon: 'fe7gme-hover.webp',
		disabled: !Store.get()?.appData?.options?.enablePassport,
		popUp: {
			copy: copy.$passport
		}
	},
	{
		id: 'travelerNotices',
		icon: 'pctorh.webp',
		activeIcon: 'pctorh-active.webp',
		idleIcon: 'pctorh-idle.webp',
		hoverIcon: 'pctorh-hover.webp',
		popUp: {
			copy: copy.$travelerNotices
		}
	},
	{
		id: 'lostAndFound',
		icon: 'azswto.webp',
		activeIcon: 'azswto-active.webp',
		idleIcon: 'azswto-idle.webp',
		hoverIcon: 'azswto-hover.webp',
		popUp: {
			copy: copy.$lostAndFound,
			items: [
				{ id: 'pineappleLuggage', asset: 'agmpac.webp' },
				{ id: 'hardShellSuitcase', asset: 'xynvmf.webp' },
				{ id: 'iglooBackpack', asset: 'fghwgm.webp' },
				{ id: 'superMushroom', asset: 'k93csj.webp' },
				{ id: 'greenTurtleShell', asset: 'dcv04k.webp' },
				{ id: 'toadsNovel', asset: 'y2ywsb.webp' },
			]
		}
	},
	{
		id: 'stayConnected',
		icon: 'zlns2g.webp',
		activeIcon: 'zlns2g-active.webp',
		idleIcon: 'zlns2g-idle.webp',
		hoverIcon: 'zlns2g-hover.webp',
		popUp: {
			copy: copy.$stayConnected
		},
		disabled: !Store.get()?.appData?.options?.enableStayConnected
	},
	{
		id: 'watchAtHome',
		icon: 'ik3gnd.webp',
		activeIcon: 'ik3gnd-active.webp',
		idleIcon: 'ik3gnd-idle.webp',
		hoverIcon: 'ik3gnd-hover.webp',
		popUp: {
			copy: copy.$watchAtHome
		},
		disabled: !Store.get()?.appData?.options?.enableHomeEnt
	},
	{
		id: 'showtimes',
		icon: 'ofoz5z.webp',
		hoverIcon: 'ofoz5z-hover.webp',
		link: copy.$showtimesLink,
		disabled: copy.$showtimesLink == '' || !copy.$showtimesLink
	}
];

export const travelerNotices = [
	{
		id: 'missingPoster',
		tabIcon: 'a9kpps.webp',
		imageMobile: '4efeul-m.webp',
		imageDesktop: '4efeul-d.webp',
		imageRegion: true
	},
	{
		id: 'starfox',
		tabIcon: 'd8ch3s.webp',
		imageMobile: 'jnc2gq-m.webp',
		imageDesktop: 'jnc2gq-d.webp',
		imageRegion: true,
		easterEgg: 'bf2cs1', //TRAVELER NOTICE EASTER EGG UPDATE
		name: copy.$travelerNotices.starfoxEasterEggHeading, //TRAVELER NOTICE EASTER EGG UPDATE
		disabled: !Store.get()?.appData?.options?.enableHomeEnt,
	},
	{
		id: 'ukikiWarning',
		tabIcon: '9ub1xc.webp',
		imageMobile: 'sqnfoa-m.webp',
		imageDesktop: 'sqnfoa-d.webp',
		imageRegion: true
	},
	{
		id: 'videoMessage',
		tabIcon: 'dxr5hs.webp',
		video: 'bzy7hp.mp4'
	},

];

export const pipes = [
	{
		id: 'pipe0',
		audio: 'pipe',
		planet: 'mushroomKingdom',
	},
	{
		id: 'pipe1',
		audio: 'pipe',
		planet: 'honeyhiveGalaxy',
	},
	{
		id: 'pipe2',
		audio: 'pipe',
		planet: 'fossilFalls',
	},
	{
		id: 'pipe3',
		audio: 'pipe',
		planet: 'cometObservatory',
	},
	{
		id: 'pipe4',
		audio: (getDateNum() === '4') ? 'pipe' : 'constructionPipe',
		underConstruction: (getDateNum() === '4') ? false : true,
		planet: (getDateNum() === '4') ? 'tostarenaTown' : undefined,
		robMsg: (getDateNum() === '4') ? undefined : 'tostarenaTown'
		
	},
	{
		id: 'pipe5',
		audio: (getDateNum() === '4') ? 'pipe' : 'constructionPipe',
		underConstruction: (getDateNum() === '4') ? false : true,
		robMsg: (getDateNum() === '4') ? undefined : 'dripDropGalaxy',
		easterEgg: (getDateNum() === '4') ? 'dripDropGalaxy' : undefined
	},
	{
		id: 'pipe6',
		audio: (getDateNum() === '4') ? 'pipe' : 'constructionPipe',
		underConstruction: (getDateNum() === '4') ? false : true,
		upWorld: (getDateNum() === '4') ? true : undefined,
		robMsg: (getDateNum() === '4') ? undefined : 'spaceJunkGalaxy'
	}
];

export const glyphs = [
	{
		id: 'bones',
		anim: 'osm2ks',
		easterEgg: 'mueo1m/exvoh5.webp',
		name: copy.$glyphs.bones
	},
	{
		id: 'butterfly',
		anim: 'm7zaij',
		easterEgg: 'mueo1m/e9u8rh.webp',
		name: copy.$glyphs.butterfly
	},
	{
		id: 'clown',
		anim: 'h8f3i0',
		easterEgg: 'mueo1m/kl3ds1.webp',
		name: copy.$glyphs.clown
	},
	{
		id: 'mustache',
		anim: 'ikn3d5',
		easterEgg: 'mueo1m/hfgb2x.webp',
		name: copy.$glyphs.mustache
	},
	{
		id: 'peaches',
		anim: 'l5nsx2',
		easterEgg: 'mueo1m/qazpyv.webp',
		name: copy.$glyphs.peaches
	},
	{
		id: 'bowser',
		anim: 'xrkc1w',
		easterEgg: 'mueo1m/awyb3d',
		name: copy.$glyphs.bowser,
		disabled: !Store.get()?.appData?.options?.enableHomeEnt,
	},
	{
		id: 'barrelRoll',
		anim: 'klmb2f',
		barrelRoll: true,
		name: copy.$glyphs.barrelRoll,
		disabled: !Store.get()?.appData?.options?.enableHomeEnt,
	}
];